import "../App.css";
import React, { useState, useEffect } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate(); // ใช้สำหรับเปลี่ยนเส้นทาง
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser); // แปลง JSON กลับเป็น object
        setUser(parsedUser); // อัปเดต state
      } catch (error) {
        console.error('Error parsing user data from localStorage', error);
        setUser(null); // หากแปลงไม่ได้ให้ตั้งค่า user เป็น null
      }
    }
  }, []);

  // ฟังก์ชันออกจากระบบ
  const handleLogout = () => {
    localStorage.removeItem('user'); // ลบข้อมูลออกจาก localStorage
    setUser(null); // อัปเดต state
    navigate('/login'); // รีไดเรกต์ไปที่หน้า login
  };

  return (
    <div className="mainNvContainer">
      <div className="mainNvBody">
        <div className="mainNvLogo">
          <div>
            <Link to="/">
              <img
                src="/logo-ps.png"
                fetchPriority="high"
                loading="lazy"
                alt="Logo"
              />
            </Link>
          </div>
        </div>

        {/* ปุ่มเมนู */}
        <input type="checkbox" id="checkbox" className="menu-toggle" />
        <label htmlFor="checkbox" className="toggle">
          <div className="bars" id="bar1"></div>
          <div className="bars" id="bar2"></div>
          <div className="bars" id="bar3"></div>
        </label>

        <div className="menuOverlay"></div>

        {/* เมนู */}
        <div className="mainNvMenus">
          <h5> Menu </h5>
          <NavLink to="/" className={({ isActive }) => (isActive ? 'mainNvActive' : '')}>
            <i className="fa-solid fa-house"></i> หน้าแรก
          </NavLink>
          <NavLink to="/repair" className={({ isActive }) => (isActive ? 'mainNvActive' : '')}>
            <i className="fa-solid fa-gear"></i> แจ้งซ่อม
          </NavLink>
          <NavLink to="/status" className={({ isActive }) => (isActive ? 'mainNvActive' : '')}>
            <i class="fa-solid fa-square-poll-vertical"></i> ติดตามสถานะ
          </NavLink>

          {user ? (
            <span className="userGreeting">
              <i className="fa-solid fa-user"></i> {user.name}
              <button className="LogoutButton" onClick={handleLogout}>
                <i className="fa-solid fa-arrow-right-from-bracket"></i>
              </button>
            </span>
          ) : (
            <NavLink to="/login" className={({ isActive }) => (isActive ? 'mainNvActive' : '')}>
              <i className="fa-solid fa-arrow-right-to-bracket"></i> เข้าสู่ระบบ (สำหรับ Admin)
            </NavLink>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;